import { haveRole } from '@/lib/admin/getIsUserBackOffice'
import { CONSTANTS } from '@/types/enum/constants'
import { Session } from './AuthClient'
import { useSession } from './hooks'

export interface CareImpersonation {
  /** Connexion déléguée en cours (en-tête X-Switch-User envoyé à l'API). */
  isImpersonating: boolean
  /**
   * Connexion déléguée ouverte par un super admin : le paramétrage Care est accessible, les
   * données patient restent masquées par l'API (CARE_CONFIG_ACCESS côté @group-api).
   */
  isSuperAdminImpersonator: boolean
  /** Paramétrage Care modifiable : session normale, ou délégation par un super admin. */
  canManageCareConfig: boolean
}

// session.user.roles garde les rôles de l'administrateur d'origine : switchUserRoles porte
// ceux du compte usurpé et ne les écrase jamais (AuthClient.overrideRolesSession).
export const getCareImpersonation = (session: Session): CareImpersonation => {
  const isImpersonating = Boolean(session?.switchUser)
  const isSuperAdminImpersonator =
    isImpersonating && haveRole(session?.user?.roles ?? [], [CONSTANTS.ROLE_SUPER_ADMIN])

  return {
    isImpersonating,
    isSuperAdminImpersonator,
    canManageCareConfig: !isImpersonating || isSuperAdminImpersonator,
  }
}

export const useCareImpersonation = (): CareImpersonation => getCareImpersonation(useSession())
